































import { Component, Vue } from "vue-property-decorator";
import balancesDetail from "./BalancesDetails/index.vue";
@Component({
  components: {
    balancesDetail,
  },
})
export default class Home extends Vue {
  public payBoxChange() {
    this.$router.push({ path: "/wallet/boxTopUp" });
  }
  public balanceChange() {
    const $balancesDetail: any = this.$refs.balancesDetail;
    $balancesDetail.show();
  }
}
